import { faArrowUpFromBracket } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';

import Tooltip from '@/ui/components/Tooltip';

function CopyUrlToClipboard(): JSX.Element {
  const [copied, setCopied] = useState(false);
  const [hover, setHover] = useState(false);

  const copyUrlToClipboard = () => {
    const url = new URL(window.location.href);

    navigator.clipboard.writeText(url.toString());
    setCopied(true);
  };

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    if (copied) {
      timeout = setTimeout(() => {
        setCopied(false);
      }, 2000);
    }
    return () => clearTimeout(timeout);
  }, [copied]);

  return (
    <Tooltip
      tooltipContent={copied ? 'Copied!' : 'Copy link to clipboard'}
      disabled={!hover && !copied}>
      <button
        className="flex items-center text-gray-600 hover:text-gray-800 rounded-md px-3 py-1 text-sm font-medium"
        onClick={copyUrlToClipboard}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        type="button">
        <FontAwesomeIcon icon={faArrowUpFromBracket} className="mr-2" />
      </button>
    </Tooltip>
  );
}
export default CopyUrlToClipboard;
